module.exports = __webpack_public_path__ + "img/client-touchbase.4d04fbf7.png";